import type { State } from './types.tsx';

export const initialState: State = {
	isArchiveIssueModalOpen: false,
	issueKey: null,
	issueId: null,
	onIssueArchiveSuccess: null,
	onCloseIssueViewModal: null,
	triggerPointKey: null,
	workType: null,
};
